import { param } from "jquery";
import { request } from "../Api/Api";

export const aboutUsData = () => {
  return request.get("/about-us"); ///done
};
export const whoweare = () => {
  return request.get("/who_we_are"); //done
};
export const ourbrand = () => {
  return request.get("/our_brand"); //done
};
export const oursegment = () => {
  return request.get("/our_segment"); ///done
};
export const homeblog = () => {
  return request.get("/home_blog"); /////done
};
export const header = () => {
  return request.get("/header"); /////done
};

export const slider = () => {
  return request.get("/slider");
};
export const footer = () => {
  return request.get("/footer"); /////done
};
export const gallery = (page, perPage) => {
  return request.get(`/gallery?page=${page}&?per_page=${perPage}`); ///done
};
export const blog = (page, perPage) => {
  return request.get(`/blog?page=${page}&?per_page=${perPage}`);
};

export const setting = () => {
  return request.get("/setting"); ///done
};
export const galleryimage = (params) => {
  return request.post("/gallery-image", params); ///done
};
export const blogdetail = (params) => {
  return request.post("/blog-detail", params);
};
export const career = (page, perPage) => {
  return request.get(`/career?page=${page}&?per_page=${perPage}`); ///done
};
export const careerinquiry = (params) => {
  return request.post("/career-inquiry", params, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensure this header is set
    },
  }); ///10
};
export const careerdetails = (params) => {
  return request.get("/career-detail", params);
};
export const categoryData = () => {
  return request.get("/category"); ///done
};
export const subcategory = (params) => {
  return request.get("/subcategory", params); ///done
};
export const productData = (perPage, params) => {
  return request.get(`/product?page=${perPage}`, params); ///13
};
export const productdetail = (params) => {
  return request.get("/product-detail", params); ///14
};
export const rangeproduct = (params) => {
  return request.get("/range-product", params); ///15
};
export const customPage = (params) => {
  return request.get("/custom_page", params); ///16
};

export const getCustomAPIData = (params) => {
  return request.get(`/custom_page_detail`, params)
} 

export const searchData = (params) => {
  return request.post("/search", params); ///17
};

export const contact = (params) => {
  return request.post("/contact", params);
};
